<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <v-tabs
          v-model="tab"
          background-color="#EEEEEE"
          color="black"
          grow
      >
        <v-tab>Alle Medien</v-tab>
        <v-tab>Medien Verwaltung</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <TableAllMedien :showTitle="true" ref="table" :isCompanyView="false"/>
        </v-tab-item>
        <v-tab-item>
          <TableGlobalMedien :showTitle="true" ref="table" :isCompanyView="false"/>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
//import Vue from 'vue'
import TableGlobalMedien from "../tables/TableGlobalMedien"
import TableAllMedien from "../tables/TableAllMedien"
export default {
  name: 'Medien',
  components: {TableGlobalMedien,TableAllMedien},
  data () {
    return {
      tab: 0,
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
